/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Navigation/theme';

export const NavigationTheme = theme;
